export default "__VITE_ASSET__wa_6X56D__"